import React,{useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import heroImg from "../img/home-bg-img.jpg";
import largeLogo from "../img/large-logo.png";
import Modal from '../components/modal';

const bgStyle = {
  width: '100vw',
  height: '100vh',
  objectFit:'cover',
  position: 'absolute',
  left:'0'
};
const contentStyle = {
  position: 'relative',
  textAlign: 'center',
  display:'flex',
  flexWrap:'wrap',
  justifyContent:'center',
  alignItems:'center',
  height:'100vh',
  flexDirection:'column'
};

const logoStyle = {
  width:'100%',
  maxWidth:'600px',
  marginBottom:'40px',
  marginTop:'-80px'
};


const Home = () => {
  const [openModal,setOpenModal] = useState(false);
  return (
    <div className="container">
      <img style={bgStyle} src={heroImg} alt="heroImg" />
    	<div style={contentStyle} className="content-wrapper">
        <div><img style={logoStyle} src={largeLogo} alt="largeLogo" /></div>
        <button 
          className="openModalBtn btnBg home" 
          onClick={()=>{
            setOpenModal(true);
            }}>ENTER
          </button>
        {openModal && <Modal closeModal={setOpenModal}/>}
    	</div>
    </div>
  );
};

export default Home;
